export default (buttons, cart) => {
  let addToCartButtons = buttons;
  if (!addToCartButtons || !addToCartButtons.length) {
    addToCartButtons = [...document.querySelectorAll('.js-add-to-cart-button')];
  }

  addToCartButtons.forEach((addToCartButton) => {
    const variantID = addToCartButton.getAttribute('data-variantid');
    const item = { id: variantID, quantity: 1 };

    addToCartButton.addEventListener('click', () => {
      cart.addItems(item);
    });
  });
};
